"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemRadio = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _MenuItem = require("../components/MenuItem");
var _MenuCheckboxUrsaSvg = require("./MenuCheckboxUrsaSvg");
const getIcon = theme => {
  switch (theme) {
    case "ursa-light":
      return /*#__PURE__*/_react.default.createElement(_MenuCheckboxUrsaSvg.MenuCheckboxUrsaSvg, null);
    default:
      return /*#__PURE__*/_react.default.createElement(_lodestarIcons.CheckIcon, {
        size: "small"
      });
  }
};
const MenuItemRadio = _ref => {
  let {
    children,
    innerRef,
    onClick,
    selectedValue,
    value,
    ...rest
  } = _ref;
  const isChecked = value === selectedValue;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_MenuItem.MenuItem, (0, _extends2.default)({}, rest, {
    ref: innerRef,
    role: "menuitemradio",
    "aria-checked": isChecked ? "true" : "false",
    onClick: (e, log) => {
      if (!isChecked) {
        onClick(value, e, log);
      }
    },
    contentBefore: isChecked ? getIcon(themeMode) : null
  }), children);
};
exports.MenuItemRadio = MenuItemRadio;
//# sourceMappingURL=MenuItemRadio.js.map